/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unstable-nested-components */
import React, {
  useState, useCallback, forwardRef, useImperativeHandle, useRef, useMemo,
} from 'react';
import {
  Badge,
  Button,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from 'reactstrap';

import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import { useFetchData } from '../../hooks/useFetchData';
import { numberToCurrency } from '../../utils/functions';
import FinanceiroEdit from '../Financeiro/Edit';

const months = [
  { value: 1, label: 'Jan' },
  { value: 2, label: 'Fev' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'Abr' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Jun' },
  { value: 7, label: 'Jul' },
  { value: 8, label: 'Ago' },
  { value: 9, label: 'Set' },
  { value: 10, label: 'Out' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dez' },
];

function ModalContaPagarTableInfo(_props, ref) {
  const [show, setShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('Informações da Tabela');
  const [type, setType] = useState('conta-pagar');
  const [visibleColumnsDataFields, setVisibleColumnsDataFields] = useState(null);
  const modalFinanceiroEdit = useRef();

  const { data, loading, error, fetchData, clearData } = useFetchData({
    onError: (err, errorMessage) => {
      console.error('Error fetching modal data:', err, errorMessage);
    },
  });

  useImperativeHandle(ref, () => ({
    show: ({
      query,
      title,
      type: typeParam,
      visibleColumnsDataFields: visibleColumnsDataFieldsParam,
    }) => {
      setType(typeParam);
      setModalTitle(title);
      setVisibleColumnsDataFields(
        Array.isArray(visibleColumnsDataFieldsParam) ? visibleColumnsDataFieldsParam : null,
      );
      if (query) {
        setShow(true);
        fetchData(query);
      }
    },
    close: () => {
      setShow(false);
      clearData();
    },
  }));

  const toggle = () => setShow((prev) => !prev);

  const tipoFormatter = useCallback((row) => {
    if (row?.tipo === 'conta-pagar') {
      return (
        <Badge className="w-100" color="danger" tag="div">
          <i className="fa-solid fa-money-bill-transfer mr-2" />
          a Pagar
        </Badge>
      );
    }

    if (row?.tipo === 'conta-receber') {
      return (
        <Badge className="w-100" color="success" tag="div">
          <i className="fa-solid fa-hand-holding-dollar mr-2" />
          a Receber
        </Badge>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`tipo-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`tipo-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const formattedCanceladoBy = (row) => {
    const { agendamento: { motivoCancelamento, dataCancelamento, canceladoByCliente }, canceladoByAdmin, canceladoByProfissional } = row;

    if (canceladoByAdmin?.name) {
      return `Motivo do Cancelamento: ${motivoCancelamento || 'Não informado'}. Cancelado pelo Admin ${canceladoByAdmin.name} em ${format(new Date(dataCancelamento), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`;
    }

    if (canceladoByProfissional?.name) {
      return `Motivo do Cancelamento: ${motivoCancelamento || 'Não informado'}. Cancelado pelo Profissional ${canceladoByProfissional.name} em ${format(new Date(dataCancelamento), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`;
    }

    if (canceladoByCliente?.nome) {
      return `Motivo do Cancelamento: ${motivoCancelamento || 'Não informado'}. Cancelado pelo Cliente ${canceladoByCliente.nome} em ${format(new Date(dataCancelamento), 'dd/MM/yyyy HH:mm', { locale: ptBR })}`;
    }

    return 'Não Identificado';
  };

  const atendimentoFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'aberto') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          {/* <UncontrolledTooltip target={`agendamento-${row._id}`}>
            Clique para Cancelar.
          </UncontrolledTooltip> */}
          <span id={`agendamento-${row._id}`}>
            <i className="fa-solid fa-circle text-info mr-2" />
            Em Aberto
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-primary" /> */}
        </span>
      );
    }

    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <UncontrolledTooltip target={`agendamento-${row._id}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <span id={`agendamento-${row._id}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
          <UncontrolledTooltip target={`agendamento-eye-${row._id}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <i id={`agendamento-eye-${row._id}`} className="ml-2 fa-solid fa-eye text-primary" />
        </span>
      );
    }

    if (row?.atendimentoStatus === 'concluido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span>
            <i className="fa-solid fa-circle-check text-success mr-2" />
            Concluido
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-transparent" /> */}
        </span>
      );
    }

    return (
      <span className="d-flex w-100 justify-content-between align-items-center">
        <span>
          <i className="fa-solid fa-exclamation-circle text-secondary mr-2" />
          Sem agendamento
        </span>
        {/* <i className="ml-2 fa-solid fa-pen text-transparent" /> */}
      </span>
    );
  }, []);

  const statusFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <UncontrolledTooltip target={`agendamento-${row._id}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <span id={`agendamento-${row._id}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
          <UncontrolledTooltip target={`agendamento-eye-${row._id}`}>
            {formattedCanceladoBy(row)}
          </UncontrolledTooltip>
          <i id={`agendamento-eye-${row._id}`} className="ml-2 fa-solid fa-eye text-primary" />
        </span>
      );
    }

    if (row?.fatura === 'aberto') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`status-${row._id}`}>
            <i className="fa-solid fa-circle text-success mr-2" />
            Em Aberto
          </span>
          {/* <i className="ml-2 fa-solid fa-pen text-primary" /> */}
        </span>
      );
    }

    if (row?.fatura === 'fechado') {
      if (row?.atendimentoStatus === 'cancelado') {
        return (
          <span className="d-flex w-100 justify-content-between align-items-center">
            <span id={`status-${row._id}`}>
              <i className="fa-solid fa-circle text-warning mr-2" />
              Fechado
            </span>
          </span>
        );
      }
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`status-${row._id}`}>
            <i className="fa-solid fa-circle text-warning mr-2" />
            Fechado
          </span>
        </span>
      );
    }

    if (row?.fatura === 'emitido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`status-${row._id}`}>
            <i className="fa-solid fa-circle text-danger mr-2" />
            Emitido
          </span>
        </span>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`status-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`status-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const folhaPagamentoHumanReadableFormatter = useCallback((row) => {
    if (row?.contaDe === 'fornecedor') {
      return (
        <>
          <i className="fa-solid fa-building-user text-success mr-2" />
          Não Emite
        </>
      );
    }

    if (!row?.folhaPagamentoHumanReadable) {
      return (
        <>
          <i className="fa-solid fa-spinner text-warning mr-2" />
          Não Gerado
        </>
      );
    }

    return (
      <>
        <i className="fa-solid fa-hashtag text-danger mr-2" />
        {row?.folhaPagamentoHumanReadable}
      </>
    );
  }, []);

  const situacaoFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`agendamento-${row._id}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
        </span>
      );
    }

    if (row?.situacao === 'a-vencer') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`situacao-${row._id}`}>
            <i className="fa-solid fa-circle-info text-info mr-2" />
            A Vencer
          </span>
        </span>
      );
    }

    if (row?.situacao === 'pago') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`situacao-${row._id}`}>
            <i className="fa-solid fa-circle-check text-success mr-2" />
            Pago
          </span>
        </span>
      );
    }

    if (row?.situacao === 'vencido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <UncontrolledTooltip target={`situacao-${row._id}`}>
            Clique para Pagar.
          </UncontrolledTooltip>
          <span id={`situacao-${row._id}`}>
            <i className="fa-solid fa-circle-xmark text-danger mr-2" />
            Vencido
          </span>
        </span>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`situacao-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`situacao-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const nameFormatter = useCallback((row) => {
    if (row?.profissionalNome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
            Profissional
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${row._id}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.profissionalNome}
        </div>
      );
    }

    if (row?.clienteNome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
            Paciente
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${row._id}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.clienteNome}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`nome-tipo-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const grupoFormatter = useCallback((row) => {
    if (row?.grupoNome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
            Profissional
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${row._id}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.grupoNome}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`nome-tipo-${row._id}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`nome-tipo-${row._id}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const columns = useCallback(
    () => [
      {
        dataField: 'tipo',
        text: 'Módulo',
        formatter: tipoFormatter,
        className: 'text-center',
        width: '120px',
      },
      {
        dataField: 'atendimento',
        text: 'Atendimento',
        formatter: atendimentoFormatter,
        className: 'text-center',
        width: '150px',
      },
      {
        dataField: 'grupo',
        text: 'Grupo',
        formatter: grupoFormatter,
        width: '150px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'name',
        text: type === 'conta-receber' ? 'Paciente' : 'Profissional',
        formatter: nameFormatter,
        width: '300px',
      },
      {
        dataField: 'mesAtendimento',
        text: 'Mês do Atendimento',
        formatter: (row) => {
          if (!row.mes || !row.ano) return '-';
          const mesNum = parseInt(row.mes, 10);
          if (Number.isNaN(mesNum)) return '-';
          const month = months.find((m) => m.value === mesNum);
          return month ? `${month.label}/${row.ano}` : 'Inválido';
        },
        className: 'text-center',
        width: '150px',
      },
      {
        dataField: 'dataAtendimento',
        text: 'Data Atendimento',
        formatter: (row) => {
          if (!row.startAtendimentoDate) return 'Sem Data';
          try {
            return format(parseISO(row.startAtendimentoDate), 'dd/MM/yyyy');
          } catch (err) {
            return 'Data Inválida';
          }
        },
        width: '130px',
      },
      {
        dataField: 'tipoLancamento',
        text: 'Tipo',
        className: 'text-center',
        width: '200px',
      },
      {
        dataField: 'empresaPagante',
        text: 'Empresa Pagante',
        formatter: (row) => (row.razaoSocial ? `${row.razaoSocial} (${row.cnpj})` : '-'),
        width: '300px',
      },
      {
        dataField: 'valor',
        text: 'Valor',
        formatter: (row) => (row?.tipoLancamento === 'REEMBOLSO' ? numberToCurrency(row?.valorReembolso || 0) : numberToCurrency(row?.valor || 0)),
        width: '150px',
      },
      {
        dataField: 'nomeTitularConta',
        text: 'Titular da Conta',
        formatter: (row) => row?.nomeTitularConta || '-',
        width: '200px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'nomeBanco',
        text: 'Banco',
        formatter: (row) => row?.nomeBanco || '-',
        width: '150px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'numeroBanco',
        text: 'Nº Banco',
        formatter: (row) => row?.numeroBanco || '-',
        width: '150px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'tipoConta',
        text: 'Tipo de Conta',
        formatter: (row) => row?.tipoConta || '-',
        width: '150px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'numeroAgencia',
        text: 'Nº Agência',
        formatter: (row) => row?.numeroAgencia || '-',
        width: '100%',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'numeroConta',
        text: 'Nº Conta',
        formatter: (row) => row?.numeroConta || '-',
        width: '150px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'digitoConta',
        text: 'Dígito Conta',
        formatter: (row) => row?.digitoConta || '-',
        width: '100px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'formaPagamento',
        text: 'Forma de Pagamento',
        formatter: (row) => row?.formaPagamento || '-',
        width: '150px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'chavePix',
        text: 'Chave Pix',
        formatter: (row) => row?.chavePix || '-',
        width: '150px',
        hidden: type === 'conta-receber',
      },
      {
        dataField: 'status',
        text: 'Fatura',
        formatter: statusFormatter,
        className: 'text-center',
        width: '170px',
      },
      {
        dataField: 'folhaPagamentoHumanReadable',
        text: 'Nº Fatura',
        formatter: folhaPagamentoHumanReadableFormatter,
        width: '120px',
      },
      {
        dataField: 'situacao',
        text: 'Situação',
        formatter: situacaoFormatter,
        className: 'text-center',
        width: '120px',
      },
      {
        dataField: 'dataFechamento',
        text: 'Fechamento',
        formatter: (row) => {
          if (!row.dataFechamento) return 'Sem Fechamento';
          try {
            return format(parseISO(row.dataFechamento), 'dd/MM/yyyy');
          } catch (err) {
            return 'Data Inválida';
          }
        },
        width: '150px',
      },
      {
        dataField: 'dataVencimento',
        text: 'Vencimento',
        formatter: (row) => {
          if (!row.dataVencimento) return 'Sem Vencimento';
          try {
            return format(parseISO(row.dataVencimento), 'dd/MM/yyyy');
          } catch (err) {
            return 'Data Inválida';
          }
        },
        width: '150px',
      },
      {
        dataField: 'dataEmissao',
        text: 'Emissão',
        formatter: (row) => {
          if (!row.dataEmissao || row.status !== 'emitido') return 'Não Emitido';
          try {
            return format(parseISO(row.dataEmissao), 'dd/MM/yyyy HH:mm');
          } catch (err) {
            return 'Data Inválida';
          }
        },
        width: '170px',
      },
      {
        dataField: 'dataPagamento',
        text: 'Data de Pagamento',
        formatter: (row) => {
          if (!row.dataPagamento || row.situacao !== 'pago') return 'Em Aberto';
          try {
            return format(parseISO(row.dataPagamento), 'dd/MM/yyyy HH:mm');
          } catch (err) {
            return 'Data Inválida';
          }
        },
        width: '170px',
      },
      {
        dataField: 'observacoesInternas',
        text: 'Observações Internas',
        width: '200px',
        hidden: type === 'conta-receber',
      },
    ],
    [
      tipoFormatter,
      atendimentoFormatter,
      grupoFormatter,
      nameFormatter,
      statusFormatter,
      folhaPagamentoHumanReadableFormatter,
      situacaoFormatter,
      type,
    ],
  );

  const visibleColumns = useMemo(() => {
    const baseColumns = columns().filter((column) => !column.hidden);
    if (!Array.isArray(visibleColumnsDataFields)) {
      return baseColumns;
    }
    const detailOnlyColumns = ['dataAtendimento', 'valor'];
    const allowedFields = new Set([
      ...visibleColumnsDataFields,
      ...detailOnlyColumns,
    ]);
    return baseColumns.filter((column) => allowedFields.has(column.dataField));
  }, [columns, visibleColumnsDataFields]);

  return (
    <Modal isOpen={show} toggle={toggle} fullscreen>
      <ModalHeader>
        <strong>{modalTitle}</strong>
        <Button
          className="close position-absolute top-4 right-4 py-1 px-2"
          onClick={toggle}
        >
          <i className="fas fa-times" />
        </Button>
      </ModalHeader>
      <ModalBody>
        <Container fluid>
          <FinanceiroEdit ref={modalFinanceiroEdit} />
          <Row>
            <Col>
              {loading ? (
                <div className="text-center p-4">
                  <i className="fa-solid fa-spinner fa-spin fa-2x text-primary" />
                  <p className="mt-2">Carregando dados...</p>
                </div>
              ) : error ? (
                <div className="text-center p-4">
                  <i className="fa-solid fa-exclamation-triangle fa-2x text-danger" />
                  <p className="mt-2 text-danger">{error}</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <Table striped hover>
                    <thead>
                      <tr>
                        {visibleColumns.map((column) => (
                          <th
                            key={column.dataField}
                            className={`${column.className || ''} text-nowrap`}
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              maxWidth: column.width || '200px',
                              width: column.width || 'auto',
                            }}
                          >
                            {column.text}
                          </th>
                        ))}
                        <th className="text-center" style={{ width: '80px' }}>
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((row, index) => (
                        <tr key={row._id || index}>
                          {visibleColumns.map((column) => (
                            <td
                              key={column.dataField}
                              className={`${column.className || ''} text-nowrap`}
                              style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                maxWidth: column.width || '200px',
                                width: column.width || 'auto',
                              }}
                              title={column.formatter ? '' : (row[column.dataField] || '-')}
                            >
                              {column.formatter ? column.formatter(row) : row[column.dataField] || '-'}
                            </td>
                          ))}
                          <td>
                            <Button color="primary" onClick={() => modalFinanceiroEdit.current.show(row)}>
                              <i className="fa-solid fa-pen" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {data.length === 0 && (
                    <div className="text-center p-4">
                      <i className="fa-solid fa-inbox fa-2x text-muted" />
                      <p className="mt-2 text-muted">Nenhum dado encontrado</p>
                    </div>
                  )}
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default forwardRef(ModalContaPagarTableInfo);
